module.exports = __webpack_public_path__ + "static/media/give-us-a-call-icon.aa05f80f.svg";